import { useQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

export interface GetEnterpriseMemberIdsParams {
  enterpriseId: number
}

const getEnterpriseMemberIds = async ({ enterpriseId }: GetEnterpriseMemberIdsParams) => {
  const response = await getRequest<number[]>(`/enterprise/${enterpriseId}/members/user-ids`)
  return response
}

export default function useGetEnterpriseMemberIds({ enterpriseId }: GetEnterpriseMemberIdsParams) {
  return useQuery({
    ...queries.enterprise.memberUserIds(enterpriseId),
    queryFn: () => getEnterpriseMemberIds({ enterpriseId }),
    enabled: enterpriseId > 0,
    staleTime: 5 * 60 * 1000,
    retry: 3,
    retryDelay: 1000,
  })
}
